import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// this page is DEPRECATED - we now redirect people to support.mirinae.io

import LandingPageContainer from '@mirinae/explorer/containers/common/LandingPageContainer';

const LandingPage = () => {
    useEffect(() => {
        document.body.id = 'landing-page';
    }, []);

    return (
        <>
            <HelmetProvider>
                <Helmet
                    meta={[
                        { property: 'keywords', content: 'Learning Korean, Korean explorer, Korean analyzer, Korean grammar, sentence analyzer, learning language, Study Korean, AI learning language, k-pop, k-drama' },
                    ]}
                >
                    <title>Mirinae Korean Language Learning Resources</title>
                </Helmet>
            </HelmetProvider>
            <LandingPageContainer />
        </>
    );
};

export default LandingPage;